<script setup>
import { computed, provide, useSlots, toRef } from "vue";

defineOptions({
  name: "sakura-tabs",
});

const props = defineProps({
  modelValue: {},
  block: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "change"]);

const handleTabClick = (tabName) => {
  emit("update:modelValue", tabName);
  emit("change", tabName);
};

const isBlock = computed(() => props.block);

provide("tabs", { handleTabClick, modelValue: toRef(props, "modelValue") });

const slots = useSlots();
</script>

<template>
  <div :class="{ 'sakura-tabs': true, block: isBlock }">
    <div class="sakura-header">
      <slot></slot>
      <span><slot name="add"></slot></span>
    </div>
    <div class="sakura-toolbar">
      <slot name="toolbar"></slot>
    </div>
  </div>
</template>

<style scoped>
/* Add your styles here */
</style>
